import type { SVGProps } from "react"
import React from "react"

export const ArrowLeftThin: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Arrow Left Thin Icon</title>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1981 11.6115C21.1981 11.7574 21.1402 11.8973 21.037 12.0005C20.9339 12.1036 20.794 12.1615 20.6481 12.1615H4.93813L10.9381 18.1615C10.9893 18.2128 11.03 18.2736 11.0577 18.3405C11.0854 18.4074 11.0997 18.4791 11.0997 18.5515C11.0997 18.624 11.0854 18.6957 11.0577 18.7626C11.03 18.8295 10.9893 18.8903 10.9381 18.9415C10.8869 18.9928 10.8261 19.0334 10.7592 19.0611C10.6923 19.0888 10.6206 19.1031 10.5481 19.1031C10.4757 19.1031 10.404 19.0888 10.3371 19.0611C10.2701 19.0334 10.2093 18.9928 10.1581 18.9415L3.15813 11.9415C3.05672 11.837 3 11.6972 3 11.5515C3 11.4059 3.05672 11.266 3.15813 11.1615H3.07813L10.0781 4.16154C10.1816 4.05811 10.3219 4 10.4681 4C10.6144 4 10.7547 4.05811 10.8581 4.16154C10.9616 4.26498 11.0197 4.40526 11.0197 4.55154C11.0197 4.69782 10.9616 4.83811 10.8581 4.94154L4.72813 11.0715H20.6481C20.7199 11.0702 20.7912 11.0832 20.8579 11.1097C20.9245 11.1363 20.9852 11.1758 21.0364 11.2261C21.0877 11.2764 21.1283 11.3364 21.1561 11.4026C21.1838 11.4687 21.1981 11.5398 21.1981 11.6115Z"
    />
  </svg>
)
